import RentalCalculationReviewBreakdownModel from './RentalCalculationReviewBreakdownModel';

export default class RentalCalculationReviewBreakdown {
  inputFields: Array<{
    fieldId: number;
    fieldName: string;
    fieldValue: string;
  }>;

  rentalAddressId: number;
  calculationId: number;
  calculationItems: RentalCalculationReviewBreakdownModel;

  constructor(data = {}, id = null) {
    this.rentalAddressId = id;

    this.calculationId = this.calculationItems =
      'genericIncomeData' in data
        ? data.genericIncomeData[0]?.calculationId
        : 0;

    this.calculationItems =
      data &&
      'genericIncomeData' in data &&
      data.genericIncomeData[0]?.calculationItems?.[0]
        ? new RentalCalculationReviewBreakdownModel(
            data.genericIncomeData[0].calculationItems[0],
          )
        : new RentalCalculationReviewBreakdownModel();

    this.inputFields =
      'genericIncomeData' in data
        ? data?.genericIncomeData[0]?.inputFields
        : null;
  }

  getRentalAddressId() {
    return this.rentalAddressId;
  }

  getCalculationId() {
    return this.calculationId;
  }

  getCalculationItems() {
    return this.calculationItems;
  }

  getAdjustedPITIA() {
    const filterPITIA = this.inputFields?.filter((val) => val.fieldId === -1);
    if (filterPITIA[0]?.fieldValue) {
      return filterPITIA[0]?.fieldValue;
    }
    return '';
  }

  // 605 - 31 'AdjustedMonthlyGrossIncome'
  // 607 - 32 AdjustedMonthlyGrossIncome
  getAdjustedGrossMonthlyIncome() {
    const filterGrossMonthlyIncome = this.inputFields?.filter(
      (val) => val.fieldName === 'AdjustedMonthlyGrossIncome',
    );
    if (filterGrossMonthlyIncome[0]?.fieldValue) {
      return filterGrossMonthlyIncome[0]?.fieldValue;
    }
    return '';
  }
  getPositiveNetRentalIncome() {
    const filterIncome = this.inputFields?.filter((val) => val.fieldId === -2);
    if (filterIncome[0]?.fieldValue) {
      return filterIncome[0]?.fieldValue;
    }
    return '';
  }
}
